import React, { useEffect, useState } from 'react';
import { Navbar } from 'react-bootstrap';
import { type Orders } from '../../../common/interfaces';

interface SalesFloorBannerProps {
  orders: Orders[];
  totalOrders: number;
}

const SalesFloorBanner: React.FC<SalesFloorBannerProps> = ({ orders, totalOrders }) => {
  const [totalPreparingOrders, setTotalPreparingOrders] = useState(0);
  const [totalPendingOrders, setTotalPendingOrders] = useState(0);
  const [totalDoneOrders, setTotalDoneOrders] = useState(0);

  useEffect(() => {
    // Filtrar solo pedidos que tengan productos de piso de venta (cocina = 0)
    const salesFloorOrders = orders.filter(order => 
      order.detalles.some(detalle => detalle.producto.cocina === 0)
    );

    const preparingCount = salesFloorOrders.filter(order => {
      const floorStatus = order.floor_status || order.status;
      return floorStatus === 'Preparing';
    }).length;
    const pendingCount = salesFloorOrders.filter(order => {
      const floorStatus = order.floor_status || order.status;
      return floorStatus === 'Pending';
    }).length;
    const doneCount = salesFloorOrders.filter(order => {
      const floorStatus = order.floor_status || order.status;
      return floorStatus === 'Done';
    }).length;

    setTotalPreparingOrders(preparingCount);
    setTotalPendingOrders(pendingCount);
    setTotalDoneOrders(doneCount);
  }, [orders]);

  return (
    <Navbar
      sticky="top"
      className="flex-column align-items-start"
      style={{
        marginTop: '0px',
        marginBottom: '10px',
        top: '60px',
        background: 'linear-gradient(135deg, #d4edda, #c3e6cb)',
        borderBottom: '3px solid #28a745',
        boxShadow: '0 2px 10px rgba(40, 167, 69, 0.2)'
      }}
    >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '15px', justifyContent: 'left', alignItems: 'flex-start', fontSize: '18px' }}>
        <div className="item-kitchen-banner">
          <Navbar.Text style={{ color: '#155724', fontSize: '18px', marginLeft: '10px', fontWeight: '500' }}>
            PEDIDOS: <strong style={{ fontSize: '25px', color: '#0d4b14' }}>{totalOrders}</strong>
          </Navbar.Text>
          <Navbar.Text style={{ color: '#155724', fontSize: '18px', marginLeft: '10px', fontWeight: '500' }}>
            PREPARANDO: <strong style={{ fontSize: '25px', color: '#0d4b14' }}>{totalPreparingOrders}</strong>
          </Navbar.Text>
        </div>
        <div className="item-kitchen-banner">
          <Navbar.Text style={{ color: '#155724', fontSize: '18px', marginLeft: '10px', fontWeight: '500' }}>
            PENDIENTES: <strong style={{ fontSize: '25px', color: '#0d4b14' }}>{totalPendingOrders}</strong>
          </Navbar.Text>
          <Navbar.Text style={{ color: '#155724', fontSize: '18px', marginLeft: '10px', fontWeight: '500' }}>
            LISTOS: <strong style={{ fontSize: '25px', color: '#0d4b14' }}>{totalDoneOrders}</strong>
          </Navbar.Text>
        </div>
      </div>
    </Navbar>
  );
};

export default SalesFloorBanner;
